/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'
import { MyprofileBirthdayWidgetMode } from '../../myprofile-birthday-widget-mode'

@UntilDestroy()
@Component({
  selector: 'myprofile-birthday-display',
  templateUrl: './myprofile-birthday-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MyProfileBirthdayDisplayComponent {
  @Input() formattedDate!: string

  @Input() editButtonLabel!: string
  @Input() deleteButtonLabel!: string
  @Input() noDateLabel!: string
  @Input() mode = MyprofileBirthdayWidgetMode.EXTERNAL
  @Input() isCnUser = false
  @Input() restrictGlobalUIChanges = false

  /** Emits the id of the control to return focus to when leaving edit mode. */
  @Output() editBirthday = new EventEmitter<string>()
  @Output() deleteBirthday = new EventEmitter()

  public MyprofileBirthdayWidgetMode = MyprofileBirthdayWidgetMode

  public triggerEdit() {
    const focusReturnId = this.mode === MyprofileBirthdayWidgetMode.PROFILE ? 'editBtn-profile' : 'editBtn-external'
    this.editBirthday.emit(focusReturnId)
  }

  public triggerDelete() {
    this.deleteBirthday.emit()
  }
}
